var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_vm._t("heading"),_c('table',{staticClass:"table"},[_c('tr',[_c('td',{staticClass:"p-0"},[_vm._t("default")],2)])]),_vm._t("charts-footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }